import React from 'react';

const FNOLContext = React.createContext({});

export default FNOLContext;
